import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import {
  AnnouncementFormType,
  AnnouncementResponse,
  GetBannerResponseType,
} from "./type";

export const AnnouncementApi = {
  getAnnouncement: (payload: AnnouncementFormType) =>
    axiosRequest.post<AnnouncementResponse>(
      "/",
      payloadHelper("Announcement", null, payload)
    ),
  async getBanner() {
    const { data } = await axiosRequest.post<GetBannerResponseType>(
      "/",
      payloadHelper("Banner", null, null)
    );
    return data;
  },
};
